export default __webpack_public_path__ + "static/media/mint-img.51353611.png";